<script>

import { Doughnut } from 'vue-chartjs'

import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels';

import chartColors from './../chart-colors'

export default {

    extends: Doughnut,

    props: {
        data : String,
        type : String,
        translations : String
    },

    data() {
        return {
            result : null
        }
    },

    mounted() {

        this.trans = JSON.parse(this.translations)

        this.result = JSON.parse(this.data)

        let labelsFromDb = Object.keys(this.result[this.type]);

        if(labelsFromDb.includes('man')) {
            labelsFromDb = this.trans.chart_gender_db;
        } else if(labelsFromDb.includes('good')) {
            labelsFromDb = this.trans.chart_good_bad_db;
        }

        const data = {
            labels: labelsFromDb,
            datasets: [
                {
                    label: 'GitHub Commits',
                    backgroundColor: chartColors,
                    data: Object.values(this.result[this.type])
                }
            ]
        }

        let options = {

            legend : {
                display: true,
                onClick: (e) => e.stopPropagation()
            },

            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }
            },

            responsive: false,
            maintainAspectRatio: false,

            tooltips : {

                callbacks: {

                    label: function(tooltipItem, data) {

                        const dataset = data.datasets[tooltipItem.datasetIndex];

                        const total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                            return previousValue + currentValue;
                        });

                        const currentValue = dataset.data[tooltipItem.index];
                        const precentage = Math.round( ( ( currentValue / total ) * 100 ) );

                        return`${precentage}%`
                    }
                }

            }
        }

        options = Object.assign(options, {

            animation: {
                duration: 0
            },

            tooltips: {
                enabled: false
            },

            plugins: {
                datalabels: {
                    formatter: (value, ctx) => {
                        let sum = 0;

                        let dataArr = ctx.chart.data.datasets[0].data.map(data => {
                            sum += data;
                        });

                        return Math.round((value * 100 / sum)) + '%'
                    },
                    color: '#fff',
                }
            }

        })

        this.renderChart(data, options)



    },

    components: {
        ChartJSPluginDatalabels
    },


}
</script>

